import { render, staticRenderFns } from "./VariantManager.vue?vue&type=template&id=5912c228&scoped=true&"
import script from "./VariantManager.vue?vue&type=script&lang=js&"
export * from "./VariantManager.vue?vue&type=script&lang=js&"
import style0 from "./VariantManager.vue?vue&type=style&index=0&id=5912c228&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5912c228",
  null
  
)

export default component.exports